export default {"src":"/_next/static/media/certisign-logo-53-26.14bf6b5f.svg","height":26,"width":53};